/* Port City Holsters — build picker helper.
   Pins the "My setup isn't listed" entry to the top of the Firearm Make & Model
   dropdown, keeps it visible while customers search, and replaces the bare
   "No results found" message with a pointer to it. Display-only: it never changes
   option values or prices, and does nothing if the Easify markup is not found. */
(function () {
  var RX = /isn.t listed/i;
  var LBL = /firearm make/i;
  function nl(w) {
    var b = w.querySelectorAll('.tpo_option-type-selection');
    for (var i = 0; i < b.length; i++) {
      var t = b[i].querySelector('.tpo_option_type_label');
      if (t && RX.test(t.textContent)) return b[i];
    }
    return null;
  }
  function keepVisible(btn) {
    btn.hidden = false;
    btn.classList.remove('hidden', 'tpo_hidden');
    if (btn.style.display === 'none') btn.style.display = '';
  }
  function setup(box) {
    if (box.__pchPicker) return;
    var lab = box.querySelector('.tpo_option-label-container');
    if (!lab || !LBL.test(lab.textContent) || /new/i.test(lab.textContent.split('Model')[0])) return;
    var w = box.querySelector('.tpo_option-type-dropdown-wrapper');
    if (!w) return;
    var btn = nl(w);
    if (!btn) return;
    box.__pchPicker = true;
    btn.classList.add('pch-notlisted');
    var search = w.querySelector('.tpo_dropdown-search-wrapper');
    var anchor = search ? search.nextSibling : w.firstChild;
    if (btn !== anchor) w.insertBefore(btn, anchor);
    var empty = w.querySelector('.tpo_option-type-selection--empty');
    if (empty) {
      empty.textContent = 'Not on our list yet? Choose \u201cMy setup isn\u2019t listed\u201d above and we will make your mold.';
      empty.classList.add('pch-empty');
      if (empty.parentNode === w && btn.nextSibling !== empty) w.insertBefore(empty, btn.nextSibling);
    }
    new MutationObserver(function () {
      if (btn.hidden || btn.classList.contains('hidden') || btn.style.display === 'none') keepVisible(btn);
    }).observe(btn, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    var inp = w.querySelector('.tpo_dropdown-search-input');
    if (inp) inp.addEventListener('input', function () { setTimeout(function () { keepVisible(btn); }, 0); });
  }
  function scan() {
    try {
      var boxes = document.querySelectorAll('.tpo_option-container');
      for (var i = 0; i < boxes.length; i++) setup(boxes[i]);
    } catch (e) {}
  }
  var css = document.createElement('style');
  css.textContent =
    '.pch-notlisted{border-bottom:1px solid rgba(77,148,236,.55)!important;background:rgba(77,148,236,.14)!important}' +
    '.pch-notlisted .tpo_option_type_label{font-weight:600}' +
    '.pch-notlisted .tpo_option_type_label:before{content:"Don\\2019t see your build? ";display:block;font-size:.78em;font-weight:500;letter-spacing:.04em;text-transform:uppercase;color:#7fb2f2;margin-bottom:.15em}' +
    '.pch-empty{font-size:.9em;color:#c9d6e6;padding:.6em .9em}';
  document.head.appendChild(css);
  scan();
  var n = 0, iv = setInterval(function () { scan(); if (++n > 40) clearInterval(iv); }, 250);
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); }).observe(document.documentElement, { childList: true, subtree: true });
})();
